import Store from 'repatch';

import State from '../core/State';
import ErrorPresenter from '../service/ErrorPresenter';
import AcctWebApi from '../service/persistent/AcctWebApi';
import { setProductPricing } from '../thunk/acct';

class AcctUsecase {
  private store: Store<State>;
  private acctWebApi: AcctWebApi;
  private errorPresenter: ErrorPresenter;

  constructor({
    store,
    acctWebApi,
    errorPresenter,
  }: {
    store: Store<State>;
    acctWebApi: AcctWebApi;
    errorPresenter: ErrorPresenter;
  }) {
    this.store = store;
    this.acctWebApi = acctWebApi;
    this.errorPresenter = errorPresenter;
  }

  public getProductPricing = async (kaizenUserId: string): Promise<void> => {
    try {
      const productPricing = await this.acctWebApi.getProductPricing(kaizenUserId);
      this.store.dispatch(setProductPricing(productPricing));
    } catch (err) {
      this.errorPresenter.showAsNonFatal(err);
    }
  };
}

export default AcctUsecase;
